export const USER_INFO = "USER_INFO";
export const MODALITY = "MODALITY";
export const USER_TOKEN = "USER_TOKEN";
export const SYMPTOM_OPTIONS = "SYMPTOM_OPTIONS";
export const SYMPTOM_OPTIONS_CN = "SYMPTOM_OPTIONS_CN";
export const ALLERGY_OPTIONS = "ALLERGY_OPTIONS";
export const ALLERGY_OPTIONS_CN = "ALLERGY_OPTIONS_CN";
export const PAST_DISEASE_OPTIONS = "PAST_DISEASE_OPTIONS";
export const PAST_DISEASE_OPTIONS_CN = "PAST_DISEASE_OPTIONS_CN";
export const CURRENT_MEDICINE_TAKEN_OPTIONS = "CURRENT_MEDICINE_TAKEN_OPTIONS";
export const CURRENT_MEDICINE_TAKEN_OPTIONS_CN = "CURRENT_MEDICINE_TAKEN_OPTIONS_CN";
export const PAYMENT_RETRY_LOG = "PAYMENT_RETRY_LOG";
export const PACKAGE_PERMISSIONS = "PACKAGE_PERMISSIONS";
export const QR_CODE_TOKEN = "QR_CODE_TOKEN";
export const READER_FONT_SIZE = "READER_FONT_SIZE";
export const STREET_TYPE = "STREET_TYPE";